// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@synd/App/Components/Common/XngZone";
import { CustomAppState } from "@synd/App/Store/Reducers";
import { XNGAGE_CUSTOM_WIDGET } from "@synd/XDL/constants";
import React, { FC } from "react";

export interface HomePageLayoutStyles {
    wrapper?: InjectableCss;
    container?: InjectableCss;
    leftSection?: InjectableCss;
    rightSection?: InjectableCss;
    verticalWrapper?: InjectableCss;
}

export const homePageLayoutStyles: HomePageLayoutStyles = {};

export const HomePageLayout: FC<WidgetProps> = ({ id }) => {
    const isTabletScreen = useAppSelector(state => (state as CustomAppState).xCommon.isTabletScreen);

    const styles = homePageLayoutStyles;

    return (
        <StyledWrapper {...styles.wrapper}>
            <XngZone zoneName="Welcoming Message" hint="Welcoming Message" contentId={id} />
            {isTabletScreen && <XngZone zoneName="Banner" hint="Banner" contentId={id} />}
            <StyledWrapper {...styles.container}>
                <StyledWrapper {...styles.leftSection}>
                    {!isTabletScreen && (
                        <>
                            <XngZone zoneName="Order Timing Reminder" hint="Order Timing Reminder" contentId={id} />
                            <XngZone zoneName="Quick Links" hint="Quick Links" contentId={id} />
                            <XngZone zoneName="Lists" hint="Lists" contentId={id} />
                        </>
                    )}
                    {isTabletScreen && (
                        <>
                            <StyledWrapper {...styles.verticalWrapper}>
                                <XngZone zoneName="Order Timing Reminder" hint="Order Timing Reminder" contentId={id} />
                                <XngZone zoneName="Quick Links" hint="Quick Links" contentId={id} />
                            </StyledWrapper>
                            <StyledWrapper {...styles.verticalWrapper}>
                                <XngZone zoneName="Lists" hint="Lists" contentId={id} />
                                <XngZone zoneName="Recent Order Status" hint="Recent Order Status" contentId={id} />
                            </StyledWrapper>
                        </>
                    )}
                </StyledWrapper>
                <StyledWrapper {...styles.rightSection}>
                    {!isTabletScreen && <XngZone zoneName="Banner" hint="Banner" contentId={id} />}
                    {!isTabletScreen && (
                        <XngZone zoneName="Recent Order Status" hint="Recent Order Status" contentId={id} />
                    )}
                    <XngZone zoneName="Orders" hint="Orders" contentId={id} />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const homePageLayout: WidgetModule = {
    component: HomePageLayout,
    definition: {
        group: XNGAGE_CUSTOM_WIDGET,
    },
};

export default homePageLayout;
